import "core-js/modules/es.array.push.js";
export default {
  name: "mMenu",
  data() {
    const menuList = [{
      label: "Main",
      value: "main"
    }, {
      label: "Tasks",
      value: "tasks"
    }, {
      label: "Leaders",
      value: "leaders"
    }, {
      label: "Invite",
      value: "invite"
    }, {
      label: "History",
      value: "history"
    }];
    return {
      menuList,
      selectMenu: null
    };
  },
  watch: {
    "$route.path": {
      handler(path) {
        if (path === "/") {
          return this.selectMenu = "main";
        }
        this.selectMenu = path.split("/")[1];
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    onMenu(item) {
      this.hapticFeedback();
      if (item.value === "main") {
        this.selectMenu = "main";
        this.$router.push(`/`);
        return;
      }
      this.selectMenu = item.value;
      this.$router.push(`/${item.value}`);
    }
  }
};